import { NavLink, Outlet } from "react-router-dom";
import { useComponentTranslation } from "@/services/i18n";
import { FiHome, FiHeart, FiGlobe, FiCreditCard, FiFileText, FiMessageCircle, FiMail, FiCode, FiZap } from "react-icons/fi";

const translations = {
  en: {
    company: "Company",
    culture: "Culture",
    career: "Career",
    billing: "Billing",
    templates: "Templates",
    whatsapp: "WhatsApp",
    email: "Email",
    screening: "AI Screening",
    iframe: "Iframe Embed",
  },
  fr: {
    company: "Entreprise",
    culture: "Culture",
    career: "Carrière",
    billing: "Facturation",
    templates: "Modèles",
    whatsapp: "WhatsApp",
    email: "Email",
    screening: "Screening IA",
    iframe: "Intégration Iframe",
  },
};

export default function SettingsLayout() {
  const { t } = useComponentTranslation(translations);

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-primary/10 text-primary border-l-3 border-primary" : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
    }`;

  return (
    <div className="flex min-h-[calc(100vh-64px)]">
      {/* Left Settings Menu */}
      <aside className="w-56 border-r border-gray-200 bg-white py-6 px-4">
        <nav className="space-y-1">
          <NavLink to="/recruiter/organisation/company" className={linkClass}>
            <FiHome className="w-4 h-4" />
            <span>{t("company")}</span>
          </NavLink>
          <NavLink to="/recruiter/organisation/career" className={linkClass}>
            <FiGlobe className="w-4 h-4" />
            <span>{t("career")}</span>
          </NavLink>
          <NavLink to="/recruiter/organisation/culture" className={linkClass}>
            <FiHeart className="w-4 h-4" />
            <span>{t("culture")}</span>
          </NavLink>
          <NavLink to="/recruiter/organisation/billing" className={linkClass}>
            <FiCreditCard className="w-4 h-4" />
            <span>{t("billing")}</span>
          </NavLink>
          <NavLink to="/recruiter/organisation/templates" className={linkClass}>
            <FiFileText className="w-4 h-4" />
            <span>{t("templates")}</span>
          </NavLink>
          <NavLink to="/recruiter/organisation/whatsapp" className={linkClass}>
            <FiMessageCircle className="w-4 h-4" />
            <span>{t("whatsapp")}</span>
          </NavLink>
          <NavLink to="/recruiter/organisation/email" className={linkClass}>
            <FiMail className="w-4 h-4" />
            <span>{t("email")}</span>
          </NavLink>
          <NavLink to="/recruiter/organisation/screening" className={linkClass}>
            <FiZap className="w-4 h-4" />
            <span>{t("screening")}</span>
          </NavLink>
          <NavLink to="/recruiter/organisation/iframe" className={linkClass}>
            <FiCode className="w-4 h-4" />
            <span>{t("iframe")}</span>
          </NavLink>
        </nav>
      </aside>

      {/* Content Area */}
      <main className="flex-1 p-8 bg-gray-50">
        <Outlet />
      </main>
    </div>
  );
}
